import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, API_BASE_URL } from '../api/client';

const Register: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage('Passwords do not match');
      return;
    }
    try {
      const response = await api.post(`/register`, { email, password });
      
      const { token, userId, is_admin } = response.data;
      if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('userId', String(userId));
        localStorage.setItem('is_admin', String(is_admin));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        // Dispatch custom event to notify App component about login state change
        window.dispatchEvent(new Event('auth-change'));
        
        let dest = '/schedule';
        try {
          const usage = await api.get(`/users/${userId}/usage`);
          const tier = usage.data?.tier;
          if (typeof tier === 'string') {
            try {
              localStorage.setItem('userTier', tier);
            } catch {}
          }
        } catch {}
        
        navigate(dest);
      } else {
        setMessage(response.data.message);
      }
    } catch (error: any) {
      setMessage(error.response?.data?.message || 'Registration failed');
    }
  };

  return (
    <div className="container mt-5">
      <h2>Register</h2>
      <form onSubmit={handleRegister}>
        <div className="mb-3">
          <label htmlFor="emailInput" className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            id="emailInput"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="passwordInput" className="form-label">Password</label>
          <input
            type="password"
            className="form-control"
            id="passwordInput"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="confirmPasswordInput" className="form-label">Confirm Password</label>
          <input
            type="password"
            className="form-control"
            id="confirmPasswordInput"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Register</button>
      </form>
      <div className="mt-4">
        <p>Or sign up with:</p>
        <a href={`${API_BASE_URL}/auth/google`} className="btn btn-outline-danger me-2">Google</a>
      </div>
      {message && <p className="mt-3 text-danger" role="alert" aria-live="assertive">{message}</p>}
    </div>
  );
};

export default Register;
